// sentinel app_ids for the agent bridge, must match forge backend exactly
export const WIDGET_MARKETPLACE_APP_ID = 'widget-marketplace'
export const PIN_AI_WIDGET_APP_ID = 'pin-ai-widget'
